var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMit = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 50 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.014 10.5v24.75H.7V10.5h5.315Zm8.657 0v16.848H9.355V10.5h5.316Zm8.656 0v24.75h-5.315V10.5h5.315Zm8.657 0v4.92h-5.316V10.5h5.316Zm3.493 24.75V18.402h5.315V35.25h-5.315Zm-8.809 0V18.402h5.316V35.25h-5.316ZM49.45 15.42H35.477V10.5H49.45v4.92Z"
})));
export default SvgMit;